import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgbCalendar, NgbDatepickerConfig, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { setDate } from '../../../shared/config/dateCommon';
import { swalError, swalInfo, swalSuccess } from '../../../shared/config/swalCommon';
import { AdjudgedService, LogsService, UserService, ValueService } from '../../../services/services.index';
import { User, QuotaTransfer, Value, Petition, LogsNav } from '../../../interfaces/interfaces.index';
import { FGCesionCupo } from 'src/app/interfaces/forms/cesion-cupo.interface';
import { Router } from '@angular/router';
import { EMAIL_PATTERN, nameMask } from 'src/app/shared';

@Component({
  selector: 'app-cesion-cupo',
  templateUrl: './cesion-cupo.component.html',
  styleUrls: ['./cesion-cupo.component.css'],
  styles: [`
    .example-form {min-width: 150px;max-width: 500px;width: 100%;}
    .example-full-width {width: 77%;}
  `]
})
export class CesionCupoComponent implements OnInit {
  hoy: NgbDate;
  quotaTransfer: QuotaTransfer;
  userLogged: User;
  td: Value[];
  hoySpanishFormat: NgbDate;
  forma: FGCesionCupo;
  petition: Petition;
  formSubmitted = false;
  nameMask = nameMask;
  emailPattern = EMAIL_PATTERN;

  constructor(
    private fb: FormBuilder,
    public dpConfig: NgbDatepickerConfig,
    public calendar: NgbCalendar,
    private spinnerService: NgxSpinnerService,
    private adjudgedService: AdjudgedService,
    private userService: UserService,
    private valueService: ValueService,
    private router: Router,
    private logService: LogsService
  ) {
    this.userLogged = this.userService.user;
    this.hoy = calendar.getToday();
    dpConfig.maxDate = { year: 2099, month: 12, day: 31 };
    this.forma = this.fb.group({
      email: [null as string | null, {
        validators: [Validators.required, Validators.pattern(EMAIL_PATTERN), Validators.email],
        updateOn: 'blur'
      }],
      name: [null as string | null, Validators.required]
    });
    this.valueService.getValuesByType('tipoident').subscribe(data => {
      this.td = data;
    }, error => this.handleError(error));

    this.petition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
   }

  ngOnInit(): void {
    this.addLogsNav();
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  handleError = (err) => { this.spinnerService.hide(); Swal.fire(swalError('Ha ocurrido un error', err.error?err.error.userMessage:err.userMessage)); };

  registrar = () => {
    this.formSubmitted = true;

    if(this.forma.invalid) {
      this.forma.markAllAsTouched();
      Swal.fire(swalInfo('Faltan campos requeridos, verifique'));
      this.formSubmitted = false;
      return;
    }

    this.spinnerService.show();
    this.adjudgedService.postQuotaTransfer(this.datosForm()).subscribe(async data => {
      this.spinnerService.hide();
      await Swal.fire(swalSuccess()).then(() => this.router.navigate([`proceso`]));
    }, error => {
      this.formSubmitted = false;
      this.handleError(error.error);
    });
  }

  datosForm = (): QuotaTransfer => {
    if (this.quotaTransfer) {
    } else {
      this.quotaTransfer = {
        name: this.name.value,
        email: this.email.value,
        petitionId: this.petition.id
      };
    }
    return this.quotaTransfer;
  }

  onBack() {
    if(this.petition.processStatus !== "Rejected") {
      if(this.petition.process == 3 || this.petition.process == 4)
        this.router.navigate([`proceso-capacidad-pago`, 1]);
      else
        this.router.navigate([`proceso-capacidad-pago`, 2]);
    }
    else {
      this.router.navigate(["opciones-capacidad-pago"]);
    }
  }

  get name() { return this.forma.get('name'); }
  get email() { return this.forma.get('email'); }
}
